import { ref, onMounted, onUnmounted } from 'vue'

export function useSidebar() {
  const mobileBreakpoint = 992
  const isSidebarOpened = ref(false)

  const isMobile = () => window.innerWidth <= mobileBreakpoint

  const openSidebar = () => {
    const body = document.body
    if (isMobile()) {
      body.classList.add('hide-all')
      window.scrollTo(0, 0)
    }
    const sidebar = document.getElementById('buy-now-sidebar')
    if (sidebar) sidebar.classList.add('opened')
    isSidebarOpened.value = true
  }

  const closeSidebar = () => {
    const body = document.body
    if (isMobile()) {
      body.classList.remove('hide-all')
    }
    const sidebar = document.getElementById('buy-now-sidebar')
    if (sidebar) sidebar.classList.remove('opened')
    isSidebarOpened.value = false
  }

  const updateBodyClassOnResize = () => {
    if (!isSidebarOpened.value) return
    const body = document.body
    if (isMobile()) {
      body.classList.add('hide-all')
    } else {
      body.classList.remove('hide-all')
    }
  }

  onMounted(() => {
    window.addEventListener('resize', updateBodyClassOnResize)
  })
  onUnmounted(() => {
    window.removeEventListener('resize', updateBodyClassOnResize)
  })

  return {
    openSidebar,
    closeSidebar,
    isSidebarOpened
  }
}
